import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10.002",
      cy: "9.999",
      r: "8.333",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.167",
      d: "M10.002 18.333a8.333 8.333 0 0 1 0-16.667M10.004 18.333a8.333 8.333 0 0 0 0-16.667",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "1.167",
      d: "m12.5 12.5-5-5M12.5 7.5l-5 5",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }